export const WELCOME_PAGE_VERSION = {
    INITIAL: 'initial',
    REDESIGN: 'redesign',
}

export const PLATFORM_SECTION_INFO_LIST = [
    {
        id: 1,
        title: 'welcome.platform.charting_title',
        descriptionList: [
            'welcome.platform.charting_indicators',
            'welcome.platform.charting_drawing',
        ],
        imageInitial: 'platform-charting',
        imageRedesign: 'platform-charting',
    },
    {
        id: 2,
        title: 'welcome.platform.space_title',
        descriptionList: [
            'welcome.platform.space_widgets',
            'welcome.platform.space_drag',
        ],
        imageInitial: 'platform-space',
        imageRedesign: 'platform-space',
    },
    {
        id: 3,
        title: 'welcome.platform.usability_title',
        descriptionList: [
            'welcome.platform.usability_multi_workspace',
            'welcome.platform.usability_multi_screen',
            'welcome.platform.usability_search',
        ],
        imageInitial: 'platform-usability',
        imageRedesign: 'platform-usability',
    },
    {
        id: 4,
        title: 'welcome.platform.watchlist_title',
        descriptionList: [
            'welcome.platform.watchlist_multi_view',
            'welcome.platform.watchlist_modes',
            'welcome.platform.watchlist_instrument',
        ],
        imageInitial: 'platform-watchlist',
        imageRedesign: 'platform-space',
    },
];
